"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adBlock = exports.doNotTrack = exports.flashDetails = exports.silverLightDetails = exports.browserPluginsOld = void 0;
const utils_1 = require("../../utils/utils");
/*eslint-enable */
function browserPluginsOld() {
    const mimetypes = (navigator === null || navigator === void 0 ? void 0 : navigator.mimeTypes) || [];
    const plugins = (navigator === null || navigator === void 0 ? void 0 : navigator.plugins) || [];
    /**
     * Most modern browsers don't allow enumeration of these items. Let's immediately return the
     * object and empty arrays if we can.
     */
    if (!mimetypes && !plugins) {
        return { installedPlugins: [] };
    }
    let i;
    const result = [];
    if (plugins.length > 0) {
        for (let i = 0; i < plugins.length; i++) {
            // const n = plugins[i].name;
            const n = utils_1.stripExtension(plugins[i].filename, '.');
            if (!utils_1.isBlank(n)) {
                result.push(n);
            }
        }
    }
    else if (mimetypes.length > 0) {
        for (i = 0; i < mimetypes.length; i++) {
            const n = mimetypes[i].description;
            if (!utils_1.isBlank(n)) {
                result.push(n);
            }
        }
    }
    return {
        installedPlugins: result
            .filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index;
        })
            .sort(),
    };
}
exports.browserPluginsOld = browserPluginsOld;
function silverLightDetails() {
    let objControl, objPlugin;
    let silverlightVersion;
    try {
        try {
            objControl = new ActiveXObject('AgControl.AgControl');
            if (objControl.IsVersionSupported('5.0')) {
                silverlightVersion = '5.x';
            }
            else if (objControl.IsVersionSupported('4.0')) {
                silverlightVersion = '4.x';
            }
            else if (objControl.IsVersionSupported('3.0')) {
                silverlightVersion = '3.x';
            }
            else if (objControl.IsVersionSupported('2.0')) {
                silverlightVersion = '2.x';
            }
            else {
                silverlightVersion = '1.x';
            }
            objControl = null;
        }
        catch (e) {
            objPlugin = navigator.plugins.namedItem('Silverlight Plug-In');
            if ((objPlugin === null || objPlugin === void 0 ? void 0 : objPlugin.description) === '1.0.30226.2') {
                silverlightVersion = '2.x';
            }
            else {
                const desc = (objPlugin === null || objPlugin === void 0 ? void 0 : objPlugin.description[0]) || '0';
                silverlightVersion = desc !== '0' ? parseInt(desc, 10) : undefined;
            }
        }
    }
    catch (err) {
        //do nothing
    }
    return silverlightVersion;
}
exports.silverLightDetails = silverLightDetails;
function flashDetails() {
    return undefined;
}
exports.flashDetails = flashDetails;
function doNotTrack() {
    const track = navigator.doNotTrack;
    if (track === null || track === 'unspecified') {
        return 'unspecified';
    }
    if (track === '1' || track === 'yes') {
        return 'true';
    }
    return 'false';
}
exports.doNotTrack = doNotTrack;
function adBlock() {
    const ads = document.createElement('div');
    ads.innerHTML = '&nbsp;';
    ads.className = 'adsbox';
    let result = false;
    try {
        document.body.appendChild(ads);
        const resEl = document.getElementsByClassName('adsbox')[0];
        result = resEl.offsetHeight === 0;
        document.body.removeChild(ads);
    }
    catch (e) {
        result = false;
    }
    return `${result}`;
}
exports.adBlock = adBlock;
//# sourceMappingURL=plugins.js.map